/* --------------------------------------------------

		!!!!!!!!!!!!!!!!!!!!!!!
		!!!!!! IMPORTANT !!!!!!
		!!!!!!!!!!!!!!!!!!!!!!!

DO NOT MODIFY THIS FILE UNLESS YOU'VE

>>>> READ THE DOCS <<<<

AND

UNDERSTAND ALL THE CONCEPTS, INTERACTIONS & COMPONENTS

drag-and-drop: 
https://www.npmjs.com/package/react-beautiful-dnd 

API: 
https://fitsw.atlassian.net/wiki/spaces/FITSW/pages/112951297/Events+API#Get-Event-Details

flexbox: 
https://css-tricks.com/snippets/css/a-guide-to-flexbox/

CONSIDERING THIS: DOCUMENT ALL CHANGES & ADDITIONS!

-------------------------------------------------- */

import React, { useState, useEffect, useRef } from 'react'
import {
	useDispatch,
	useSelector,
} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Tooltip from 'react-bootstrap/Tooltip'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import AutosizeInput from 'react-input-autosize'
import {
	DragDropContext,
	Droppable,
	Draggable,
} from 'react-beautiful-dnd'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import {
	useEvent
} from '../../../hooks/events'
import useWindowSize from '../../../hooks/useWindowSize'
import {
	deleteItem,
	copySuperset,
	splitSuperset,
	groupSuperset,
	deleteSuperset,
	ungroupSuperset,
	updateExerciseSet,
	updateRoutineOrder,
	editRoutineHeading,
	autoFillExerciseSets,
	createRoutineHeading,
	removeRoutineHeadings,
	updateExerciseDetails,
	updateSupersetSetCount,
	updateExerciseSetCount,
	updateTrackedExerciseItems,
	clearAssignedExerciseSets,
	removeExercisesFromWorkout,
	fillExerciseWithLastAssignedData,
} from '../../../state/events'
import {update as updateResourceLibrary} from '../../ResourceLibrary/slice'
import {
	setShow as setShowCalculator,
	setWorkout as setCalculatorWorkout,
	setExercise as setCalculatorExercise,
	setSetId as setCalculatorSetId,
} from '../../../state/percentMaxCalculator'
import {
	generateReadableStandardDuration,
	isStandardDuration
} from '../../../util/datetime'
import {
	workoutFieldsPriorityMap,
	workoutIsPlayable
} from '../../../util/events'
import {
	removeNonNumeric,
	capitalize,
	nMap
} from '../../../util/util'
import styles from './Routine.module.css'
import { useDebounceCallback } from '@react-hook/debounce'
import EllipsisMenu from '../../EllipsisMenu/EllipsisMenu'
import {update as updateVideoModal } from '../../VideoModal/slice'
import { Link } from 'react-router-dom'
import YoutubeModal from '../../YoutubeModal/YoutubeModal'
import { VscClearAll } from 'react-icons/vsc'
import groupMenuPic from '../../../assets/event-editor-group-menu.png'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as faIcons  from '@fortawesome/free-solid-svg-icons'

import { DndProvider,useDrag,useDrop } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const MAX_TRACKABLE_ITEMS = 5
const TRACKABLE_ITEM_LABEL_MAP = {
	reps:'Reps',
	weight:'Weight',
	time:'Time',
	rest:'Rest',
	notes:'Notes',
	rep_range:'Rep Range',
	resistance:'Resistance',
	incline:'Incline',
	distance:'Distance',
	rpe:'RPE',
	amrap:'AMRAP'
}
const TRACKABLE_ITEM_PILL = 'TRACKABLE_ITEM_PILL'

const isTimedValue = v => ['rest', 'time'].includes(v)

const forceNotesToEnd = items => {
	if(items.includes('notes')){
		const result = []
		items.forEach(item=>{
			if(item!=='notes') result.push(item)
		})
		result.push('notes')
		return result
	}else {
		return items
	}
}

/**
 * Takes nested routine array and flattens it into array of objects like
 * [{id:<int>,type:<string>}]
 * Current implemantation is O(n^2) but exercises are small so this is 
 * still trivial
 */
const extractRoutineOrder = routine => routine.reduce(
	(carry, group) => (
		//create new flat array by spreading carry
		//then mapping current group and spreading the result
		[
			//spread carry 
			...carry,
			//map and spread
			...(
				group.type === 'heading'
				? [group]
				: group.exercises.map( exercise => (
					{ id: exercise.exercise_id, type: exercise.type }
				))
			)
		]

	)//end reduction function
	,
	//intialize as empty array
	[]
)//end extractRoutineOrder

const ExerciseGroup = ({ group, idx, routineMode, toggleSelectedItems, compactMode, isSelected }) => {
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const libraryIsOpen = useSelector(state => state.resourceLibrary.show)
	const [mode, setMode] = useState('default')
	const rowId = `exercise-group-${group.id}`
	const workout_id = group.exercises[0].workout_id
	const [status, setStatus] = useState('idle')

	const [windowWidth] = useWindowSize()

	const [demoVideoShow, setDemoVideoShow] = useState(false);
	const [demoVideo, setDemoVideo] = useState("");

	const handleDelete = () => {
		if (!window.confirm('Are you sure?')) return
		if (group.type === 'superset') {
			//get supserset number from the group
			//by pulling it off the first exercise
			const { superset } = group.exercises[0]
			dispatch(deleteSuperset({ workout_id, superset }))
		} else {
			const exercise_type = (
				group.type === 'exerciseSingleton' ?
					'exercise' : 'cardio'
			)
			dispatch(deleteItem({
				item_id: group.exercises[0].exercise_id,
				event_id: workout_id,
				event_type: 'workout',
				exercise_type
			}))
		}
	}

	const [isFillingWithRecent,setIsFillingWithRecent] = useState(false)
	const handleFillWithMostRecent = ()=>{
		setIsFillingWithRecent(true)
		statusDispatch(fillExerciseWithLastAssignedData({
			type:group.type === 'exerciseSingleton' ? 'exercise' : 'cardio',
			id:group.exercises[0].exercise_id
		}),'exercise','edit').then(()=>{
			setIsFillingWithRecent(false)
		})
	}

	/**
	 * Helper function that resolves an exercise group to the correct
	 * component and passes the correct props to that component
	 */
	const resolveComponent = (group) => {
		switch (group.type) {
			case "superset": return <Superset
				status={status}
				setStatus={setStatus}
				compactMode={compactMode}
				superset={group}
				groupIdx={idx}
			/>
			default: return <Exercise
				status={status}
				setStatus={setStatus}
				compactMode={compactMode}
				exercise={group.exercises[0]}
			/>
		}
	}


	const handleClearAssignedValues = () => {
		setStatus('pending')
		dispatch(clearAssignedExerciseSets({
			type: group.exercises[0].type,
			id: group.exercises[0].exercise_id
		})).then(() => {
			setStatus('idle')
		})
	}
	let exercise = group.exercises[0];
	let lastExercise = group.exercises[group.exercises.length-1]
	return (
		<Draggable
			key={rowId}
			draggableId={rowId}
			index={idx}
		>
			{(provided, snapshot) => (
				<div ref={provided.innerRef} {...provided.draggableProps}>
					<div className={styles.ExerciseGroup} style={{
						paddingTop:windowWidth<=560&&group.type!=='superset'?'32px':'8px'
					}}>
						<div
							id={`group-check-tab-${exercise.exercise_id}-${exercise.type}`}
							style={{
								position:'absolute',
								top:'50%',
								left:0,
								transform:'translate(-100%,-50%)',
								background:'#fff',
								borderColor:'#ccc',
								borderWidth:'1px 0 1px 1px',
								borderStyle:'solid',
								width:'32px',
								padding:'8px',
								borderRadius:'8px 0 0 8px'
							}}
						>
							<Form.Check
								checked={isSelected}
								onChange={ (e) => {
									const add = e.target.checked
									toggleSelectedItems(group, add)
								}}
							/>
						</div>
						{/* ---- Drag Handle ---- */}
						<div
							style={{
								//hide drag handle while creating supersets
								display: routineMode === 'superset' ? 'none' : 'flex'
							}}
							className={styles.ExerciseGroupHandle}
							{...provided.dragHandleProps}
						>
							<OverlayTrigger overlay={
								<Tooltip>Drag & re-order</Tooltip>
							}>
								<i className="fas fa-grip-vertical" />
							</OverlayTrigger>
						</div>
						{resolveComponent(group)}
						<div className={styles.DeleteOptions}>
							{group.type !== 'superset' &&
								<EllipsisMenu className="ml-1 p-0">
									<OverlayTrigger placement="top" overlay={
										<Tooltip>Fill with most recently used data</Tooltip>
									}>
										<Button
											disabled={isFillingWithRecent}
											onClick={handleFillWithMostRecent}
											variant="link"
											size="sm"
										>
											{isFillingWithRecent
												? <Spinner variant="primary" animation="border" size="sm" style={{ fontSize: '12px' }} />
												: <i className="fas fa-file-import" style={{ fontSize: '12px' }} />
											}
										</Button>
									</OverlayTrigger>
									<OverlayTrigger placement="top" overlay={
										<Tooltip>View Progress History</Tooltip>
									}>
										<Button
											as={Link}
											to={`/exercise_progress/?client=${exercise.client_id}&exerciseID=${exercise.exercise_db_id}`}
											variant="link"
											size="sm"
										>
											<i className="fa fa-chart-line" style={{ fontSize: '12px' }} />
										</Button>
									</OverlayTrigger>
									{Boolean(exercise.preview_src) &&
										<OverlayTrigger overlay={
											<Tooltip>
												{exercise.name}
												<img
													style={{ width: `${exercise.preview_width || 180}px` }}
													src={exercise.preview_src}
												/>
											</Tooltip>
										}>
											<Button variant="link" size="sm">
												<i className="fas fa-eye" />
											</Button>
										</OverlayTrigger>
									}
									{Boolean(exercise.demo_link) &&
										<OverlayTrigger placement="top" overlay={
											<Tooltip>Video Demo</Tooltip>
										}>
											<Button
												variant="link"
												size="sm"
												onClick={(e) => {
													setDemoVideo(exercise.demo_link);
													setDemoVideoShow(true);
													e.stopPropagation();
												}}
											>
												<i className="fas fa-video" style={{ fontSize: '12px' }} />
											</Button>
										</OverlayTrigger>
									}
									{Boolean(exercise.demo_video) &&
										<OverlayTrigger placement="top" overlay={
											<Tooltip>Video Demo</Tooltip>
										}>
											<Button
												variant="link"
												size="sm"
												onClick={(e) => {
													dispatch(updateVideoModal({
														show:true,
														src:exercise.demo_video,
														heading:exercise.exercise_name
													}))
													e.stopPropagation();
												}}
											>
												<i className="fas fa-video" style={{ fontSize: '12px' }} />
											</Button>
										</OverlayTrigger>
									}
									{exercise.type === 'exercise' &&
										<OverlayTrigger placement="top" overlay={
											<Tooltip>%RM Calculator</Tooltip>
										}>
											<Button
												onClick={() => {
													dispatch(setShowCalculator(true))
													dispatch(setCalculatorWorkout(exercise.workout_id))
													dispatch(setCalculatorExercise(exercise.exercise_id))
													dispatch(setCalculatorSetId(exercise.set_data[0].id))
												}}
												variant="link"
												size="sm"
											>
												<i className="fas fa-calculator" style={{ fontSize: '12px' }} />
											</Button>
										</OverlayTrigger>
									}
								</EllipsisMenu>
							}
							<YoutubeModal setDemoVideoShow={setDemoVideoShow} demoVideoShow={demoVideoShow} demoVideo={demoVideo} />
							{group.type !== 'superset' &&
								<OverlayTrigger overlay={
									<Tooltip>This will clear all the assigned values for this exercise</Tooltip>
								}>
									<button
										style={{ fontSize: '18px' }}
										onClick={handleClearAssignedValues}
										variant="link"
										className={styles.DeleteOption}
									>
										<VscClearAll />
									</button>
								</OverlayTrigger>
							}
						</div>
						{status === 'pending' &&
							<div className={styles.GroupBackdrop}>
								<Spinner animation="border" variant="light" />
							</div>
						}
					</div>
					<InsertExerciseButton heading={0} allowHeadingInsert workout_id={workout_id} insertPosition={lastExercise.routine_order + 1}/>
				</div>
			)}
		</Draggable>
	)
}

const InsertExerciseButton = ({insertPosition,heading,superset,workout_id,allowHeadingInsert})=>{
	superset = superset || 0
	heading = heading || 0
	const dispatch = useDispatch()

	const {
		show,
		insertPosition:activeInsertPosition,
		superset:activeSuperset,
		heading:activeHeading,
		replace,
	} = useSelector(state => state.resourceLibrary)
	const replacing = Boolean(replace.id)
	const isActive = (
		activeInsertPosition === insertPosition && 
		show && 
		activeSuperset === superset &&
		heading === activeHeading &&
		!replacing
	)

	const handleInsertHeading = ()=>{
		dispatch(createRoutineHeading({
			routine_order:insertPosition,
			workout_id
		}))
	}

	return (
		<div className={styles.InsertExerciseButtonContainer}>
			{
				allowHeadingInsert ?
				<div className={[styles.InsertExerciseButton,isActive?styles.Active:''].join(' ')}>
					{isActive?'>':'+'}
					<div className={styles.InsertMenu}>
						<ButtonGroup size="sm">
							<OverlayTrigger overlay={
								<Tooltip>
									Add exercise here
								</Tooltip>
							}>
								<Button 
									onClick={()=>{
										dispatch(updateResourceLibrary({
											show: true,
											insertPosition,
											superset,
											heading,
											tgtResourceId:workout_id,
											tgtResourceType:'workout',
											resourceType:'exercise',
											replace: {}
										}))
									}}
									variant="outline-success"
								>
									<i className="fas fa-running"></i> Exercise
								</Button>
							</OverlayTrigger>
							<OverlayTrigger overlay={
								<Tooltip>
									Add heading here
								</Tooltip>
							}>
								<Button 
									onClick={handleInsertHeading}
									variant="outline-primary"
								>
									<i className="fas fa-heading"></i> Heading
								</Button>
							</OverlayTrigger>
						</ButtonGroup>
						<i className="fas fa-long-arrow-alt-right"></i>
					</div>
				</div>
				:
				<OverlayTrigger overlay={
					<Tooltip>
						Add exercise here
					</Tooltip>
				}>
					<button 
						className={[styles.InsertExerciseButton,isActive?styles.Active:''].join(' ')}
						onClick={() => {
							dispatch(updateResourceLibrary({
								show: true,
								insertPosition,
								superset,
								heading:0,
								tgtResourceId:workout_id,
								tgtResourceType:'workout',
								resourceType:'exercise',
								replace: {}
							}))
						}}
					>
						{isActive?'>':'+'}
					</button>
				</OverlayTrigger>
			}
		</div>
	)
}

const GroupMenu = ({items,clearItems,routine,workout_id})=>{
	const dispatch = useDispatch()
	const [width,height] = useWindowSize()
	const [groupMenuHeight,setGroupMenuHeight] = useState(0)
	const [groupMenuTop,setGroupMenuTop] = useState(0)
	const groupMenuLeft = width < 767 ? 32 : -2
	const tickOffset = width < 767 ? 8 : -2
	const [status,setStatus] = useState('idle')
	const updateGroupMenu = ()=>{
		let minTop = Infinity
		let maxTop = -Infinity
		items.forEach( item => {
			const tabId = (
				item.type==='heading'
				? `heading-check-tab-${item.id}`
				: `group-check-tab-${item.id}-${item.type}`
			)
			const tab = document.getElementById(tabId)
			if(!tab) return
			const boundingRect = tab.getBoundingClientRect()
			const scrollOffset = document.getElementById('Routine').getBoundingClientRect().top
			const h = boundingRect.height
			const w = boundingRect.width
			const topDelta = boundingRect.top - scrollOffset
			minTop = Math.min(minTop,topDelta+h/2)
			maxTop = Math.max(maxTop,topDelta+h/2)
		})
		setGroupMenuHeight( maxTop - minTop )
		setGroupMenuTop(minTop)
	}

	const headingInSelected = items.reduce(
		(carry,item) => carry || item.type === 'heading',
		false
	)

	const handleSaveSuperset = () => {
		setStatus('pending')
		dispatch(groupSuperset({
			exercise_ids: items,
			workout_id
		})).then(() => {
			setStatus('idle')
			//deselect everything on success
			clearItems()
		})
	}

	const handleRemoveSelectedItems = ()=>{
		if(!window.confirm(`Are you sure you want to remove these ${items.length} workout items?`)) return
		const exercises = items.filter(i=>i.type!=='heading')
		const headings = items.filter(i=>i.type==='heading')
		dispatch(removeExercisesFromWorkout({
			exercises,
			workout_id
		}))
		dispatch(removeRoutineHeadings({
			ids:headings.map(h=>h.id),
			workout_id
		}))
		clearItems()
	}

	useEffect(updateGroupMenu,[items,routine,width,height])

	//available menu options
	const options = [
		{
			tip:'Uncheck all selected exercises',
			iconClass:"far fa-window-close text-danger",
			handler:clearItems,
			disabled:false
		},{
			tip:headingInSelected?'Cannot group superset while a heading is selected':'Group into superset',
			iconClass:"fa fa-layer-group text-primary",
			handler:handleSaveSuperset,
			disabled:headingInSelected
		},{
			tip:'Remove selected exercises, supersets & headings',
			iconClass:"fa fa-trash-alt text-danger",
			handler:handleRemoveSelectedItems,
			disabled:false
		}
	]

	//only render then menu if more than one item is selected
	if(items.length < 1) return null

	return (
		<>
			{items.map( item => {
				const tabId = (
					item.type === 'heading'
					? `heading-check-tab-${item.id}`
					: `group-check-tab-${item.id}-${item.type}`
				)
				const tab = document.getElementById(tabId)
				if( !tab ) return
				const boundingRect = tab.getBoundingClientRect()
				const scrollOffset = document.getElementById('Routine').getBoundingClientRect().top
				const h = boundingRect.height
				const w = boundingRect.width
				const topDelta = boundingRect.top - scrollOffset + h/2
				return (
					<div style={{
						height:'2px',
						background:`linear-gradient(to ${width<767?'left':'right'},#ccc,transparent)`,
						width:'26px',
						top:`${topDelta}px`,
						left:`${tickOffset}px`,
						position:'absolute'
					}}/>
				)
			})}
			<div style={{
				background:'#ccc',
				height:`${groupMenuHeight}px`,
				width:'2px',
				position:'absolute',
				top:`${groupMenuTop}px`,
				left:`${groupMenuLeft}px`,
				fontSize:'14px',
				transition:'0.2s',
				display:'flex',
				justifyContent:'center',
				alignItems:'center',
				flexFlow:'column',
			}}>

				<div style={{
					background:'#fff',
					border:'1px solid #ccc',
					borderRadius:'40px',
					padding:'8px 4px',
					width:'32px',
					textAlign:'center',
					boxShadow:'0 0 16px rgba(0,0,0,0.2)'
				}}>
					{status==='pending'&&
						<Spinner animation="border" size="sm" variant="primary"/>
					}
					{status!=='pending'&&options.map((opt,i)=>(
						<>
							<OverlayTrigger overlay={
								<Tooltip>
									{opt.tip}
								</Tooltip>
							}>
								<button 
									disabled={status==='pending'}
									tabIndex={0}
									onClick={()=>{
										if(opt.disabled) return
										opt.handler()
									}}
									style={{
										border:'none',
										background:'none',
										display:'block',
										width:'100%',
										padding:'0'
									}}
								>
									<i className={opt.iconClass}/>
								</button>
							</OverlayTrigger>
							{(i<options.length-1) &&
								<hr className="my-2"/>
							}
						</>
					))}
				</div>
			</div>
		</>
	)
}

const Heading = ({heading,id,routine_order,workout_id,toggleSelectedItems,isSelected,idx})=>{
	const dispatch = useDispatch()
	const handleChange = (e)=>{
		const val = e.target.value
		dispatch(editRoutineHeading({
			update:{
				heading:val
			},
			id
		}))
	}
	return (
		<Draggable
			key={`heading-${id}`}
			draggableId={`heading-${id}`}
			index={idx}
		>
			{(provided, snapshot) => (
				<div
					ref={provided.innerRef} 
					{...provided.draggableProps}
				>
					<div className={styles.HeadingContainer}>
						<div
							id={`heading-check-tab-${id}`}
							style={{
								position:'absolute',
								top:'50%',
								left:0,
								transform:'translate(-100%,-50%)',
								background:'#fff',
								borderColor:'#ccc',
								borderWidth:'1px 0 1px 1px',
								borderStyle:'solid',
								width:'32px',
								padding:'2px 8px',
								borderRadius:'8px 0 0 8px'
							}}
						>
							<Form.Check
								checked={isSelected}
								onChange={ (e) => {
									const add = e.target.checked
									toggleSelectedItems({heading,id,type:'heading',routine_order}, add)
								}}
							/>
						</div>
						{/* ---- Drag Handle ---- */}
						<div
							style={{
								//hide drag handle while creating supersets
								display: "flex"
							}}
							className={styles.ExerciseGroupHandle}
							{...provided.dragHandleProps}
						>
							<OverlayTrigger overlay={
								<Tooltip>Drag & re-order</Tooltip>
							}>
								<i className="fas fa-grip-vertical" />
							</OverlayTrigger>
						</div>
						<small className="text-muted" style={{
							position:'absolute',
							top:0,
							left:'50%',
							transform:'translate(calc(-50% + 20px),-100%)'
						}}>
							click to edit heading
						</small>
						<textarea
							className={styles.Heading}
							onBlur={handleChange}
							defaultValue={heading}
							placeholder="Heading"
						/>
					</div>
					<InsertExerciseButton 
						allowHeadingInsert 
						workout_id={workout_id} 
						insertPosition={routine_order}
						heading={id}
					/>
				</div>
			)}
		</Draggable>
	)
}

const ExercisePlaceholder = ({name,routine_order,workout_id,superset=0})=>(
	<div>
		<div className="bg-white my-2 border rounded p-2 d-flex align-items-center justify-content-center">
			<span className="mr-1">Adding {name}</span>
			<Spinner className="ml-1" animation="border" size="sm"/>
		</div>
		<InsertExerciseButton insertPosition={routine_order+1} workout_id={workout_id} heading={0} superset={superset}/>
	</div>
)

const NotesInput = ({item,width,type,exercise,setIdx})=>{
	const set = exercise.set_data[setIdx]
	const dispatch = useDispatch()
	const [localValue,setLocalValue] = useState(set.assigned[item])
	useEffect(()=>{
		setLocalValue(set.assigned[item])
	},[set.assigned[item]])
	const dispatchUpdate = (update)=>{
		dispatch(updateExerciseSet({
			update,
			exercise_id:exercise.exercise_id,
			workout_id:exercise.workout_id,
			id: set.id,
			type
		}))
	}
	const debouncedUpdate = useDebounceCallback(dispatchUpdate,400)
	const [focused,setFocused] = useState(false)
	const style = (
		focused
		? {display:'block'}
		: {height:'25px',resize:'none',width:'100%',display:'block'}
	)
	return (
		<div 
			className={styles.NotesContainer} 
			style={{width}}
		>
			<textarea 
				onChange={e=>{
					setLocalValue(e.target.value)
					debouncedUpdate({assigned_notes:e.target.value})
				}}
				placeholder="notes"
				onFocus={setFocused.bind(null,true)}
				onBlur={setFocused.bind(null,false)}
				className={
					focused
					? styles.ExpandedNotes
					: styles.TrackingInput
				}
				style={style}
				value={localValue}
			/>
		</div>
	)
}

const DropPreview = ({exercise,idx})=>{
	const dispatch = useDispatch()
	const [{canDrop,isOver}, drop] = useDrop(
		monitor => ({
			accept:TRACKABLE_ITEM_PILL,
			drop: ({key}) => {
				const update = []
				exercise.tracked_items.forEach((item,i)=>{
					if ( item === key ) return 
					if ( i === idx ) update.push(key)
					update.push(item)
				})
				if(idx===exercise.tracked_items.length){
					update.push(key)
				}
				dispatch(updateTrackedExerciseItems({
					tracked_items:update,
					id:exercise.exercise_id,
					type:exercise.type,
					workoutId:exercise.workout_id
				}))
			},
			collect: monitor => {
				const item = monitor.getItem()
				const isDragging = Boolean(item)
				const canDrop = monitor.canDrop()
				const sameExercise = exercise.exercise_id === item?.exercise.exercise_id
				const itemIdx = item?.exercise.tracked_items.indexOf(item.key)
				const sameIdx = idx === itemIdx
				const insertingAfterSelf = idx === itemIdx + 1
				return ({
					isOver: monitor.isOver(),
					canDrop:canDrop && isDragging && sameExercise && !sameIdx && !insertingAfterSelf,
				})
			}
		}),
		[exercise]
	)

	return (
		<div ref={drop} style={{
			width:(
				canDrop
				? (isOver?'40px':'6px')
				: 0
			),
			transition:'0.1s'
		}}>
			<span style={{
				display:isOver?'block':'none',
				height:'20px',
				width:'100%',
				background:'rgba(0,0,50,0.2)',
				borderRadius:'5px'
			}}/>
		</div>
	)
}

const TrackableItemPill = ({toggleItem,item,exercise,idx})=>{
	const [{ isDragging }, drag] = useDrag(() => ({
		type: TRACKABLE_ITEM_PILL,
		item:{key:item,exercise},
		collect: (monitor) => ({
			isDragging: Boolean(monitor.isDragging())
		})
	}),[exercise,idx])
	return (
		<>
			<div 
				ref={item!=='notes'?drag:null} 
				className="border border-secondary rounded mr-1 mb-1 text-light bg-primary d-flex align-items-center"
				style={{cursor:'default'}}
			>
				{item!=='notes'&&<i className="fa fa-grip-vertical pr-2 pl-1" style={{fontSize:'12px',cursor:'grab'}}/>}
				{item==='notes'&&<span className="pl-2"/>}
				<small className="d-block">{TRACKABLE_ITEM_LABEL_MAP[item]}</small>
				<i className="fa fa-times pl-2 pr-1" onClick={toggleItem.bind(null,item)} style={{fontSize:'12px',cursor:'pointer'}}/>
			</div>
			{item!=='notes'&&
				<DropPreview exercise={exercise} idx={idx+1} />
			}
		</>
	)
}

const TrackableSelector = ({trackedItems,trackableItems,hide,toggleItem,exercise})=>{
	return (
		<div className={styles.TrackableSelector} onClick={hide}>
			<div onClick={e=>{e.stopPropagation()}}>
				<div className="d-flex justify-content-between">
					<span>
						Edit tracked items - <span className={trackedItems.length>=MAX_TRACKABLE_ITEMS?'text-danger':'text-dark'}>{trackedItems.length}/{MAX_TRACKABLE_ITEMS}</span>
					</span>
					<Button onClick={hide} variant="outline-danger" size="sm">
						<i className="fa fa-times"/>
					</Button>
				</div>
				<hr className="my-1"/>
				<div className="d-flex flex-wrap">
					<DndProvider backend={HTML5Backend}>
						<DropPreview exercise={exercise} idx={0}/>
						{exercise.tracked_items.map(
							(item,idx) => <TrackableItemPill key={item} toggleItem={toggleItem} item={item} exercise={exercise} idx={idx}/>
						)}
					</DndProvider>
					{trackedItems.length>0&&<span className="mr-1">|</span>}
					{trackableItems.filter(item=>!trackedItems.includes(item)).map(
						item=>(
							<div 
								className="border border-secondary px-3 rounded mr-1 mb-1"
								style={{cursor:'pointer'}}
								onClick={toggleItem.bind(null,item)}
							>
								<small className="d-block">{TRACKABLE_ITEM_LABEL_MAP[item]}</small>
							</div>
						)
					)}
				</div>
				<small className="d-none d-md-block mb-1">
					<i className="fa fa-info-circle" /> Reps, AMRAP and Rep Range cannot be selected at the same time.
				</small>
			</div>
		</div>
	)
}

const RepRange = ({item,width,type,exercise,setIdx})=>{
	const set = exercise.set_data[setIdx]
	const dispatch = useDispatch()
	const [localLowValue,setLocalLowValue] = useState(set.assigned.reps)
	const [localHighValue,setLocalHighValue] = useState(set.assigned.reps_upper_limit)
	useEffect(()=>{
		setLocalLowValue(set.assigned.reps)
	},[set.assigned.reps])
	
	useEffect(()=>{
		setLocalHighValue(set.assigned.reps_upper_limit)
	},[set.assigned.reps_upper_limit])
	const dispatchUpdate = (update)=>{
		dispatch(updateExerciseSet({
			update,
			exercise_id:exercise.exercise_id,
			workout_id:exercise.workout_id,
			id: set.id,
			type
		}))
	}
	const debouncedUpdate = useDebounceCallback(dispatchUpdate,400)
	return (
		<div 
			style={{width,marginRight:'8px'}}
			className="d-flex justify-content-between"
		>
			<input 
				onChange={e=>{
					setLocalLowValue(e.target.value)
					debouncedUpdate({assigned_reps:e.target.value})
				}}
				style={{width:'40%'}}
				className={[styles.TrackingInput,type==='exercise'?styles.Exercise:styles.Cardio].join(' ')}
				size="sm" 
				placeholder="low" 
				value={localLowValue} 
			/>
			<span>-</span>
			<input 
				onChange={e=>{
					setLocalHighValue(e.target.value)
					debouncedUpdate({assigned_reps_upper_limit:e.target.value})
				}}
				style={{width:'40%'}}
				className={[styles.TrackingInput,type==='exercise'?styles.Exercise:styles.Cardio].join(' ')}
				size="sm" 
				placeholder="high" 
				value={localHighValue} 
			/>
		</div>
	)
}

const TrackingInput = ({item,width,type,exercise,setIdx,showLabels})=>{
	const set = exercise.set_data[setIdx]
	const dispatch = useDispatch()
	const [localValue,setLocalValue] = useState(set.assigned[item])
	useEffect(()=>{
		setLocalValue(set.assigned[item])
	},[set.assigned[item]])
	const dispatchUpdate = (update)=>{
		dispatch(updateExerciseSet({
			update,
			exercise_id:exercise.exercise_id,
			workout_id:exercise.workout_id,
			id: set.id,
			type
		}))
	}
	const debouncedUpdate = useDebounceCallback(dispatchUpdate,400)
	return (
		<div className={styles.TrackingInputContainer} style={{width}}>
			{(Boolean(localValue)&&showLabels)&&
				<small className={styles.InputLabel}>{TRACKABLE_ITEM_LABEL_MAP[item]}</small>
			}
			<input 
				onChange={e=>{
					setLocalValue(e.target.value)
					const updateKey = `assigned_${item}`
					debouncedUpdate({
						[updateKey]:e.target.value
					})
				}}
				disabled={ item === 'amrap' }
				
				className={[
					styles.TrackingInput,
					type==='exercise'
						? styles.Exercise
						: styles.Cardio
				].join(' ')}
				size="sm" 
				placeholder={TRACKABLE_ITEM_LABEL_MAP[item]} 
				value={item==='amrap'?'':localValue} 
			/>
		</div>
	)
}

const TrackingItem = (props)=>{
	switch(props.item){
		case "notes": return (
			<NotesInput 
				{...props}
			/>
		)
		case "rep_range": return (
			<RepRange {...props}/>
		)
		default: return <TrackingInput {...props}/>
	}
}

const Exercise = ({exercise})=>{
	const [windowWidth] = useWindowSize()
	const workout = useEvent('workout',exercise.workout_id)
	const dispatch = useDispatch()
	const [status,setStatus] = useState('idle')
	const handleChangeSetCount = newValue => {
		setStatus('pending')
		dispatch(updateExerciseSetCount({
			exercise_id: exercise.exercise_id,
			sets: newValue,
			type:exercise.type
		})).then(() => {
			setStatus('idle')
		})
	}
	const debouncedHandleChangeSetCount = useDebounceCallback(
		handleChangeSetCount,
		300
	)

	const replace = useSelector(
		state => state.resourceLibrary.replace
	)

	const replacing = (
		(replace.id === exercise.exercise_id) &&
		(replace.type === exercise.type)
	)

	const handleReplace = () => {
		//if current exercise is the one getting replaced
		//then toggle the replace off.
		//else enable replace for clicked exercise
		if (replacing) {
			dispatch(updateResourceLibrary({
				replace: {}
			}))
		} else {
			dispatch(updateResourceLibrary({
				show: true,
				replace: {
					type: exercise.type,
					id: exercise.exercise_id,
				},
				resourceType:'exercise',
				tgtResourceType:'workout',
				tgtClientId:exercise.workout_id
			}))
		}
	}

	const swapTrackedItem = (prev,current)=>{
		//check if current selected item is already part of the 
		//list of tracked items. If it is swap the prev and current
		//items. Otherwise replace prev with current
		const disjoint = ['reps','amrap','rep_range']
		const update = exercise.tracked_items.map( item => {
			if (exercise.tracked_items.includes(current)) {
				if (item===current) {
					return prev
				}
				if (item===prev) {
					return current
				}
				return item
			} else {
				if (item===prev) return current
				return item
			}
		}).filter(i=>{
			if (
				disjoint.includes(current)
				&& disjoint.includes(i)
				&& i!==current
			) {
				return false
			}
			return true
		})
		dispatch(
			updateTrackedExerciseItems({
				tracked_items:update,
				id:exercise.exercise_id,
				type:exercise.type,
				workoutId:exercise.workout_id
			})
		)
	}

	const toggleItem = item => {
		if(exercise.tracked_items.includes(item)){
			dispatch(
				updateTrackedExerciseItems({
					tracked_items:forceNotesToEnd(exercise.tracked_items.filter(i=>i!==item)),
					id:exercise.exercise_id,
					type:exercise.type,
					workoutId:exercise.workout_id
				})
			)
		}else if(exercise.tracked_items.length<MAX_TRACKABLE_ITEMS) {
			//reps, AMRAP and rep range are disjoint
			//so toggle the others off if one of them is selected
			const disjoint = ['reps','amrap','rep_range']
			const update = [
				...exercise.tracked_items,
				item
			].filter(i=>{
				if(disjoint.includes(item)&&disjoint.includes(i)&&i!==item){
					return false
				}
				return true
			})
			dispatch(
				updateTrackedExerciseItems({
					tracked_items:forceNotesToEnd(update),
					id:exercise.exercise_id,
					type:exercise.type,
					workoutId:exercise.workout_id
				})
			)
		}
	}

	const trackable_items = (
		exercise.type==='exercise'
		? [
			'reps',
			'rep_range',
			'amrap',
			'rpe',
			'weight',
			'time',
			'rest',
			'notes'
		]
		: [
			'time',
			'distance',
			'rpe',
			'resistance',
			'incline',
			'rest',
			'notes'
		]
	)

	const [showTrackableSelector,setShowTrackableSelector] = useState(false)
	return (
		<div className="w-100">
			<div className="d-flex align-items-start mb-2">
				<div className="mr-2 d-flex">
					<small className="d-block mr-1" style={{lineHeight:'25px'}}># Sets:</small>
					<input 
						defaultValue={exercise.sets}
						onChange={e=>{
							debouncedHandleChangeSetCount(e.target.value)
						}}
						size="sm" 
						className={styles.SetsInput} 
						placeholder="sets"
					/>
				</div>
				<div className={replacing && 'text-primary'} onClick={handleReplace} style={{cursor:'pointer'}}>
					{replacing &&
						<i className="fas fa-exchange-alt mr-1" />
					}
					<small><strong>{exercise.exercise_name}</strong></small>
				</div>
			</div>
			<div className="d-flex">
				{!Boolean(workout.compact_mode)&&
					<div className={styles.SetNumberCol}>
						<span style={{height:'31px'}}>
							Set
						</span>
						{exercise.set_data.map(
							(_,i) => <span>{i+1}</span>
						)}
					</div>
				}
				<div className={["w-100",styles.ExerciseGroupCol,'mx-2'].join(' ')}>
					<div className={styles.TrackableDropdowns}>
						{exercise.tracked_items.map((item,i)=>(
							<div key={item} className={styles.TrackableItem}>
								<Form.Control 
									onChange={e=>{
										swapTrackedItem(item,e.target.value)
									}}
									as="select" 
									size="sm" 
									value={item}
								>
									{
										trackable_items
											//only allow notes to be selected in the last drop down
											.filter( 
												trackable => (
													trackable !== 'notes'
													? trackable
													: i === exercise.tracked_items.length - 1
												)
											)
											.map(
												item => (
													<option key={item} value={item}>
														{TRACKABLE_ITEM_LABEL_MAP[item]}
													</option>
												)
											)
									}
								</Form.Control>
							</div>
						))}
					</div>
					<OverlayTrigger overlay={
						<Tooltip>Add/remove tracked items (weight,rpe etc)</Tooltip>
					}>
						<Button 
							className={styles.MobileTrackableEditorToggle}
							onClick={setShowTrackableSelector.bind(null,true)} 
							variant="outline-primary"
							size="sm" 
							block
						>
							Edit tracked items (weight,rpe etc)
						</Button>
					</OverlayTrigger>
					{!Boolean(workout.compact_mode)&&exercise.set_data.map(
						(set,i) => (
							<>
								<div className={styles.MobileSetNumber}>
									<small>Set {i+1}</small>
								</div>
								<div key={i} className={styles.TrackingItemGroup}>
									{exercise.tracked_items.map(
										item => 
											windowWidth <= 560
											? <div className="d-flex align-items-end">
												<small className="mr-1" style={{width:'60px',flex:'0 0 auto'}}>
													<strong>
														{TRACKABLE_ITEM_LABEL_MAP[item]}:
													</strong>
												</small>
												<TrackingItem 
													width="100%"
													exercise={exercise}
													setIdx={i}
													exerciseId={exercise.exercise_id}
													workoutId={exercise.workout_id}
													item={item}
													type={exercise.type}
												/>
											</div>
											: <TrackingItem 
												width={`${100/exercise.tracked_items.length}%`}
												exercise={exercise}
												setIdx={i}
												exerciseId={exercise.exercise_id}
												workoutId={exercise.workout_id}
												item={item}
												type={exercise.type}
											/>
									)}
								</div>
							</>
						)
					)}
					{Boolean(workout.compact_mode)&&
						<div className={styles.TrackingItemGroup}>
							{exercise.tracked_items.map(
								item => (
									windowWidth <= 560
									? <div className="d-flex align-items-end">
										<small className="mr-1" style={{width:'60px',flex:'0 0 auto'}}>
											<strong>
												{TRACKABLE_ITEM_LABEL_MAP[item]}:
											</strong>
										</small>
										<TrackingItem 
											width="100%"
											exercise={exercise}
											setIdx={0}
											exerciseId={exercise.exercise_id}
											workoutId={exercise.workout_id}
											item={item}
											type={exercise.type}
										/>
									</div>
									: <TrackingItem 
										width={`${100/exercise.tracked_items.length}%`}
										exercise={exercise}
										setIdx={0}
										exerciseId={exercise.exercise_id}
										workoutId={exercise.workout_id}
										item={item}
										type={exercise.type}
									/>
								)
							)}
						</div>
					}
				</div>
				<div className={styles.DesktopExerciseRightCol}>
					<div>
						<OverlayTrigger overlay={
							<Tooltip>Add/remove trackable items (weight,rpe etc)</Tooltip>
						}>
							<Button 
								onClick={setShowTrackableSelector.bind(null,true)} 
								variant="outline-primary"
								size="sm" 
							>
								<FontAwesomeIcon icon={faIcons.faPlusMinus}/>
							</Button>
						</OverlayTrigger>
					</div>
					{!Boolean(workout.compact_mode)&&exercise.set_data.map(
						(_,i) => (
							<div>
								
							</div>
						)
					)}
				</div>
			</div>
			
			{showTrackableSelector&&
				<TrackableSelector 
					trackableItems={trackable_items}
					trackedItems={exercise.tracked_items}
					hide={setShowTrackableSelector.bind(null,false)}
					toggleItem={toggleItem}
					MAX_TRACKABLE_ITEMS={exercise.tracked_items.length}
					exercise={exercise}
				/>
			}
			{status==='pending'&&
				<div
					style={{
						position:'absolute',
						top:0,left:0,
						width:'100%',
						height:'100%',
						background:'rgba(0,0,0,0.4)',
						borderRadius:'15px 6px 6px 15px',
						zIndex:18,
						display:'flex',
						alignItems:'center',
						justifyContent:'center'
					}}
				>
					<Spinner animation="border" variant="white"/>
				</div>
			}
		</div>
	)
}

const SupersetExercise = ({exercise,setIdx})=>{
	const [windowWidth] = useWindowSize()
	const workout = useEvent('workout',exercise.workout_id)
	const dispatch = useDispatch()
	const set = exercise.set_data[setIdx]
	const trackable_items = (
		exercise.type === 'exercise'
		? [
			'reps',
			'rep_range',
			'amrap',
			'rpe',
			'weight',
			'time',
			'rest',
			'notes'
		]
		: [
			'time',
			'distance',
			'rpe',
			'resistance',
			'incline',
			'rest',
			'notes'
		]
	)
	const [showTrackableSelector,setShowTrackableSelector] = useState(false)

	const replace = useSelector(state => state.resourceLibrary.replace)
	const replacing = (
		(replace.id === exercise.exercise_id) &&
		(replace.type === exercise.type)
	)

	const handleReplace = () => {
		//if current exercise is the one getting replaced
		//then toggle the replace off.
		//else enable replace for clicked exercise
		if (replacing) {
			dispatch(updateResourceLibrary({
				replace: {}
			}))
		} else {
			dispatch(updateResourceLibrary({
				show: true,
				replace: {
					type: exercise.type,
					id: exercise.exercise_id,
				},
				resourceType:'exercise',
				tgtResourceType:'workout',
				tgtClientId:exercise.workout_id
			}))
		}
	}

	return (
		<div className="w-100 mb-2">
			<div className={replacing && 'text-primary'} onClick={handleReplace} style={{cursor:'pointer',marginBottom:'4px'}}>
				{replacing &&
					<i className="fas fa-exchange-alt mr-1" />
				}
				<small><strong>{exercise.exercise_name}</strong></small>
			</div>
			<div className="d-flex">
				<div className={["w-100",styles.ExerciseGroupCol,'mx-2'].join(' ')}>
					<div className={styles.TrackingItemGroup}>
						{exercise.tracked_items.map(
							item => (
								windowWidth <= 560
								? <div className="d-flex">
									<small className="mr-1" style={{width:'60px',flex:'0 0 auto'}}>
										<strong>
											{TRACKABLE_ITEM_LABEL_MAP[item]}:
										</strong>
									</small>
									<TrackingItem 
										width="100%"
										value={set.assigned[item]}
										exercise={exercise}
										type={exercise.type}
										item={item}
										setIdx={setIdx}
									/>
								</div>
								: <TrackingItem 
									width={`${100/exercise.tracked_items.length}%`}
									value={set.assigned[item]}
									exercise={exercise}
									type={exercise.type}
									item={item}
									setIdx={setIdx}
									showLabels={true}
								/>
							)
						)}
					</div>
				</div>
			</div>

		</div>
	)
}

const SupersetEditorExercise = ({exercise,setIdx,idx})=>{
	const workout_id = exercise.workout_id
	const dispatch = useDispatch()
	const trackableItems = (
		exercise.type==='cardio'
		? [
			'time',
			'distance',
			'rpe',
			'resistance',
			'incline',
			'rest',
			'notes'
		]
		:[
			'reps',
			'rep_range',
			'amrap',
			'rpe',
			'weight',
			'time',
			'rest',
			'notes'
		]
	)
	const set = exercise.set_data[setIdx]
	const toggleItem = item => {
		if(exercise.tracked_items.includes(item)){
			dispatch(
				updateTrackedExerciseItems({
					tracked_items:forceNotesToEnd(exercise.tracked_items.filter(i=>i!==item)),
					id:exercise.exercise_id,
					type:exercise.type,
					workoutId:exercise.workout_id
				})
			)
		}else if (exercise.tracked_items.length<MAX_TRACKABLE_ITEMS) {
			//reps, AMRAP and rep range are disjoint
			//so toggle the others off if one of them is selected
			const disjoint = ['reps','amrap','rep_range']
			const update = [
				...exercise.tracked_items,
				item
			].filter(i=>{
				if(disjoint.includes(item)&&disjoint.includes(i)&&i!==item){
					return false
				}
				return true
			})
			dispatch(
				updateTrackedExerciseItems({
					tracked_items:forceNotesToEnd(update),
					id:exercise.exercise_id,
					type:exercise.type,
					workoutId:exercise.workout_id
				})
			)
		}
	}
	const handleRemoveExercises = (exercise)=>{
		if(!window.confirm(`Are you sure you want to remove this exercise?`)) return
		dispatch(removeExercisesFromWorkout({
			exercises:[exercise],
			workout_id
		}))
	}
	const [showTrackableSelector,setShowTrackableSelector] = useState(false)

	const replace = useSelector(state => state.resourceLibrary.replace)
	const replacing = (
		(replace.id === exercise.exercise_id) &&
		(replace.type === exercise.type)
	)

	const handleReplace = () => {
		//if current exercise is the one getting replaced
		//then toggle the replace off.
		//else enable replace for clicked exercise
		if (replacing) {
			dispatch(updateResourceLibrary({
				replace: {}
			}))
		} else {
			dispatch(updateResourceLibrary({
				show: true,
				replace: {
					type: exercise.type,
					id: exercise.exercise_id,
				},
				resourceType:'exercise',
				tgtResourceType:'workout',
				tgtClientId:exercise.workout_id
			}))
		}
	}

	return (
		<div className="w-100 d-flex">
			<div className="d-flex align-items-start flex-wrap w-100">
				<div className="d-flex align-items-start">
					<div className={replacing && 'text-primary'} onClick={handleReplace} style={{cursor:'pointer'}}>
						{replacing &&
							<i className="fas fa-exchange-alt mr-1" />
						}
						<small><strong>{exercise.exercise_name}</strong></small>
						<span className="ml-1">
							<span className={exercise.tracked_items.length>=MAX_TRACKABLE_ITEMS?'text-danger':'text-dark'}>{exercise.tracked_items.length}/{MAX_TRACKABLE_ITEMS}</span>
						</span>
					</div>
				</div>
				<div className="d-flex flex-wrap ml-auto">
					<DndProvider backend={HTML5Backend}>
						<DropPreview exercise={exercise} idx={0}/>
						{exercise.tracked_items.map(
							(item,idx) => <TrackableItemPill toggleItem={toggleItem} item={item} exercise={exercise} idx={idx}/>
						)}
					</DndProvider>
					<span className="mr-1">|</span>
					{trackableItems.filter(item=>!exercise.tracked_items.includes(item)).map(
						item=>(
							<div 
								className="border border-secondary px-3 rounded mr-1 mb-1"
								style={{cursor:'pointer'}}
								onClick={toggleItem.bind(null,item)}
							>
								<small className="d-block">{TRACKABLE_ITEM_LABEL_MAP[item]}</small>
							</div>
						)
					)}
				</div>
			</div>
			<OverlayTrigger overlay={
				<Tooltip>Remove from superset</Tooltip>
			}>
				<Button 
					onClick={()=>{
						handleRemoveExercises({
							id:exercise.exercise_id,
							type:exercise.type,
						})
					}}
					className="text-danger ml-auto" 
					variant="link" 
					size="sm"
				>
					<i className="fa fa-times"/>
				</Button>
			</OverlayTrigger>
		</div>
	)
}

const SupersetEditorItem = ({item,idx})=>{
	const children = (()=>{
		switch(item.type){
			case "cardio":
			case "exercise": return <SupersetEditorExercise exercise={item} setIdx={0} idx={idx}/>
			default: return <div>unsupported type {item.type}</div>
		}
	})()

	if (item.type==='placeholder') {
		return (
			<ExercisePlaceholder 
				name={item.name}
				routine_order={item.routine_order}
				superset={item.superset}
				workout_id={item.workout_id}
			/>
		)
	}

	return (
		<Draggable
			key={item.exercise_id}
			draggableId={`supserset-item-${item.exercise_id}`}
			index={idx}
		>
			{(provided, snapshot) => (
				<div
					className="pb-1" 
					ref={provided.innerRef} 
					{...provided.draggableProps}
				>
					<div className="border rounded px-2 py-1 ml-2 d-flex align-items-center bg-white">
						<OverlayTrigger overlay={
							<Tooltip>Drag & re-order</Tooltip>
						}>
							<i 
								ref={provided.innerRef}
								{...provided.dragHandleProps}
								className="fas fa-grip-vertical text-muted" 
							/>
						</OverlayTrigger>
						<span className="mx-1">|</span>
						{children}
					</div>
					<InsertExerciseButton 
						workout_id={item.workout_id}
						heading={0}
						insertPosition={item.routine_order+1} 
						superset={item.superset}
					/>
				</div>
			)}
		</Draggable>
	)
}

const SupersetEditor = ({superset,hide,groupIdx})=>{
	const dispatch = useDispatch()
	const supersetNum = superset.exercises[0].superset
	const workout_id = superset.exercises[0].workout_id
	const {routine} = useEvent('workout',workout_id)
	const exercises = superset.exercises
	const handleDragEnd = result => {
		if (exercises.length <= 1 || !Boolean(result.destination)) return
		const { source: { index: srcIdx }, destination: { index: tgtIdx } } = result
		//get a temp array with the src item removed
		const tmpNoSrc = [
			...exercises.slice(0, srcIdx),
			...exercises.slice(srcIdx + 1)
		]
		
		//perform deep copy "hack" so we can mutate the update object
		//with the new routine orders
		const routineUpdate = JSON.parse(JSON.stringify(routine))
		const exercisesUpdate = JSON.parse(JSON.stringify([
			...tmpNoSrc.slice(0, tgtIdx),
			exercises[srcIdx],
			...tmpNoSrc.slice(tgtIdx)
		]))

		routineUpdate[groupIdx].exercises = exercisesUpdate

		//get smallest routine order value occuring in superset
		let i = exercises.reduce(
			(carry,exercise) => Math.min(carry,exercise.routine_order),
			exercises[0].routine_order
		)
		routineUpdate.forEach( group => {
			if(group.type==='heading') return
			group.exercises.forEach( exercise => {
				exercise.routine_order = i
				i += 1
			})
		})

		//dispatch async api action to persist the new order
		dispatch(updateRoutineOrder({
			new_order: extractRoutineOrder(routineUpdate),
			event_type: 'workout',
			event_id: workout_id,
			//update is passed only so that we can set the new routine
			//in [updateRoutineOrder.pending] (ie optimistic UI update)
			routineUpdate,
		}))
	}
	return (
		<div className={styles.SupersetEditor}>
			<div>
				<div className="d-flex align-items-center justify-content-between">
					<small><strong>Editing superset</strong></small>
					<Button onClick={hide} variant="outline-danger" size="sm">
						<i className="fa fa-times"/>
					</Button>
				</div>
				<hr className="my-1"/>
				<div className="mb-3">
					<InsertExerciseButton workout_id={workout_id} insertPosition={exercises[0].routine_order}  heading={0} superset={exercises[0].superset}/>
					<DragDropContext onDragEnd={handleDragEnd}>
						<Droppable droppableId={`superset-list-${exercises[0].exercise_id}`} type="EXERCISES">
							{(provided, snapshot) => (
								<div
									{...provided.droppableProps}
									ref={provided.innerRef}
								>
									{superset.exercises.map(
										(item,idx)=> <SupersetEditorItem item={item} idx={idx}/>
									)}
									{provided.placeholder}
								</div>
							)}
						</Droppable>
					</DragDropContext>
				</div>
			</div>
		</div>
	)
}

const Superset = ({superset,groupIdx})=>{
	const dispatch = useDispatch()
	const [status,setStatus] = useState('idle')
	const handleChange = newValue => {
		setStatus('pending')
		dispatch(updateSupersetSetCount({
			workout_id: superset.exercises[0].workout_id,
			superset: superset.exercises[0].superset,
			sets:parseInt(newValue)
		})).then(() => {
			setStatus('idle')
		})
	}
	const handleSplitSuperset = () => {
		dispatch(ungroupSuperset({
			superset: superset.exercises[0].superset,
			workout_id: superset.exercises[0].workout_id
		}))
	}
	const handleCopy = ()=>{
		dispatch(copySuperset({
			routine_order: superset.exercises[superset.exercises.length-1].routine_order,
			superset: superset.exercises[0].superset,
			workout_id: superset.exercises[0].workout_id
		}))
	}
	const debouncedHandleChange = useDebounceCallback(
		handleChange,
		300
	)
	const [showEditor,setShowEditor] = useState(false)
	const workout = useEvent('workout',superset.exercises[0].workout_id)
	return (
		<div className="w-100">
			<div className="d-flex align-items-center flex-wrap-reverse">
				<div className="mr-2 d-flex">
					<small className="d-block mr-1" style={{lineHeight:'25px'}}># Supersets:</small>
					<input 
						defaultValue={superset.sets}
						onChange={e=>{
							debouncedHandleChange(e.target.value)
						}}
						size="sm" 
						className={styles.SetsInput} 
						placeholder="sets"
					/>
				</div>
				<div>
					<Button onClick={handleSplitSuperset} size="sm" variant="link" className="text-primary">
						<i className="fas fa-object-ungroup"/> Ungroup
					</Button>
					<Button onClick={setShowEditor.bind(null,true)} size="sm" variant="link" className="text-primary">
						<i className="fa fa-edit"/> Edit
					</Button>
					<Button onClick={handleCopy} size="sm" variant="link" className="text-primary">
						<i className="fa fa-copy"/> Copy
					</Button>
				</div>
			</div>
			<small className="d-block my-1">
				<i className="fa fa-info-circle"/> Click "edit" to change tracked items and the order of items in the superset
			</small>
			{!Boolean(workout.compact_mode)&&nMap(superset.sets,(i)=>{
				return (
					<div className="mb-3">
						<div className={styles.SupersetNumber}>
							<span>Superset {i+1}</span>
						</div>
						{superset.exercises.map(
							(exercise)=>{
								switch(exercise.type){
									case "cardio":
									case "exercise": return (
										<SupersetExercise 
											exercise={exercise} 
											key={i} 
											setIdx={i}
										/>
									)
									default: return <div>unsupported type {exercise.type}</div>
								}
							}
						)}
					</div>
				)
			})}
			{Boolean(workout.compact_mode)&&
				<div className="mb-3">
					{superset.exercises.map(
						(exercise)=>{
							switch(exercise.type){
								case "cardio":
								case "exercise": return (
									<SupersetExercise 
										exercise={exercise} 
										setIdx={0}
									/>
								)
								default: return <div>unsupported type {exercise.type}</div>
							}
						}
					)}
				</div>
			}
			{showEditor&&
				<SupersetEditor superset={superset} hide={setShowEditor.bind(null,false)} groupIdx={groupIdx}/>
			}
			{status==='pending'&&
				<div style={{
					position:'absolute',
					top:0,left:0,
					width:'100%',
					height:'100%',
					background:'rgba(0,0,0,0.4)',
					borderRadius:'15px 6px 6px 15px',
					zIndex:18,
					display:'flex',
					alignItems:'center',
					justifyContent:'center'
				}}>
					<Spinner animation="border" variant="white"/>
				</div>
			}
		</div>
	)
}

/**
 * WARNING: This is a COMPLEX component EDIT WITH CARE
 */
const Routine = ({ workout_id }) => {
	const dispatch = useDispatch()
	const workout = useEvent('workout', workout_id)
	const routine = workout?.routine

	//get replace state. This holds the id and type of the exercise
	//getting replaced. id will be falsey
	const replace = useSelector(
		state => state.resourceLibrary.replace
	)

	const detailsLoading = useSelector(
		state => state.allEvents.detailsLoading
	)

	const replacing = Boolean(replace.id)

	const libraryIsOpen = useSelector(
		state => state.resourceLibrary.show
	)

	/* --- local state ---*/

	//default | superset | replace
	const [mode, setMode] = useState('default')
	const [selectedItems, setSelectedItems] = useState([])
	/* --- Handlers --- */
	const toggleSuperset = () => {
		if (mode === 'superset') {
			//when cancelling superset mode clear out the selected items
			setSelectedItems([])
			setMode('default')
		} else {
			setMode('superset')
		}
	}

	const addSelectedItems = routineItem => {
		if(routineItem.type === 'heading'){
			setSelectedItems(
				prev => [
					...prev,
					routineItem
				].sort(
					(a, b) => (a.routine_order < b.routine_order ? -1 : 1)
				)
			)
		}else{
			setSelectedItems(
				prev => [
					...prev,
					...routineItem.exercises.map(exercise => ({
						id: exercise.exercise_id,
						type: exercise.type,
						//store routine_order so we can sort
						routine_order: exercise.routine_order
					}))
				].sort(
					(a, b) => (a.routine_order < b.routine_order ? -1 : 1)
				)
			)
		}
		
	}

	const removeSelectedItems = routineItem => {
		if(routineItem.type==='heading'){
			setSelectedItems(selectedItems.filter(selectedItem=>(
				selectedItem.type !== 'heading' || selectedItem.id !== routineItem.id
			)))
		}else{
			setSelectedItems(selectedItems.filter(supersetExercise => {
				for (let i = routineItem.exercises.length - 1; i >= 0; i--) {
					const groupExercise = routineItem.exercises[i]
					const shouldRemove = (
						(groupExercise.type === supersetExercise.type) &&
						(groupExercise.exercise_id === supersetExercise.id)
					)
					if (shouldRemove) return false
				}
				return true
			}))
		}
	}

	const handleSplitSuperset = group => {
		dispatch(splitSuperset({
			superset: group.exercises[0].superset,
			workout_id
		}))
	}

	const toggleSelectedItems = (group, add) => {
		if (add) addSelectedItems(group)
		else removeSelectedItems(group)
	}

	const handleDragEnd = result => {
		if (routine.length <= 1 || !Boolean(result.destination)) return
		const { source: { index: srcIdx }, destination: { index: tgtIdx } } = result
		//get a temp array with the src item removed
		const tmpNoSrc = [
			...routine.slice(0, srcIdx),
			...routine.slice(srcIdx + 1)
		]
		//define the update with the src item at the target index
		//perform deep copy "hack" so we can mutate the update object
		//with the new routine orders
		const routineUpdate = JSON.parse(JSON.stringify([
			...tmpNoSrc.slice(0, tgtIdx),
			routine[srcIdx],
			...tmpNoSrc.slice(tgtIdx)
		]))

		//update the routine orders to reflect the new order
		//tree: type -> id -> routine_order
		const routineItemOrderTree = {
			cardio:{},
			exercise:{},
			heading:{}
		}
		let i = 1
		routineUpdate.forEach( routineItem => {
			if(routineItem.type === 'heading'){
				//WARNING headings should not increment the i
				routineItemOrderTree.heading[routineItem.id] = i
			}else{
				routineItem.exercises.forEach( exercise => {
					routineItemOrderTree[exercise.type][exercise.exercise_id] = i
					exercise.routine_order = i
					i += 1
				})
			}
		})

		//dispatch async api action to persist the new order
		dispatch(updateRoutineOrder({
			new_order: extractRoutineOrder(routineUpdate),
			event_type: 'workout',
			event_id: workout_id,
			//update is passed only so that we can set the new routine
			//in [updateRoutineOrder.pending] (ie optimistic UI update)
			routineUpdate,
		}))
		//additionally update the order of selectedItems so that 
		//when exercises are grouped the order is NOT reverted
		//to the order that existed when they were selected
		setSelectedItems(
			prev => prev.sort(
				(a, b) => (
					routineItemOrderTree[a.type][a.id] < routineItemOrderTree[b.type][b.id] 
						? -1 
						: 1
				)//end sort comparer
			)//end sort
		)//end setSelectedItems
	}

	const isPlayable = workout && workoutIsPlayable(workout)
	

	if (!routine) return (
		<div className="d-flex justify-content-center p-5">
			<Spinner animation="border" variant="primary" />
		</div>
	)

	const getRoutineInsertPosition = ()=>{
		//need last heading id so we can correctly insert the exercise at the end 
		//after the last heading
		let lastHeading = 0
		for (var i = routine.length - 1; i >= 0; i--) {
			const group = routine[i]
			//track the last heading and skip the rest
			if (group.type==='heading') {
				if (!lastHeading) lastHeading = group.id
				continue
			}
			const lastExercise = group.exercises[group.exercises.length-1]
			return [lastExercise.routine_order + 1,lastHeading]
		}
		return [1,lastHeading]
		
	}

	const itemIsSelected = item => selectedItems.reduce((carry,compare)=>{
		if(item.type==='heading'){
			return (
				carry || (item.id === compare.id)
			)
		}else{
			return (
				carry || (item.exercises[0].exercise_id === compare.id && item.exercises[0].type === compare.type)
			)
		}
	},false)
	
	return (
		<div 
			className="position-relative pl-3 pl-md-5"
			id="Routine"
		>
			{routine.length > 0 &&
				<>
					<div className="d-flex justify-content-end">
						<small className={["mr-auto", replacing ? 'text-primary' : 'text-dark'].join(' ')}>
							<i className={["fas mr-1", replacing ? 'fa-exchange-alt' : 'fa-info-circle'].join(' ')} />
							{
								replacing ?
									'You are currently replacing an exercise. Select from the library above'
									:
									'Click on an exercise name to replace it with another'
							}
						</small>
						<OverlayTrigger overlay={
							<Popover>
								<Popover.Content className="text-center">
									Check multiple exercises and a menu with extra options will appear.
									<img src={groupMenuPic} className="d-block w-100 rounded border"/>
								</Popover.Content>
							</Popover>
						}>
							<Button
								variant="outline-primary"
								className="ml-1"
								size="sm"
							>
								Superset <i className="fas fa-layer-group" />
							</Button>
						</OverlayTrigger>
						<OverlayTrigger overlay={
							<Tooltip>{libraryIsOpen ? "Close Exercise Library" : "Add Exercises"}</Tooltip>
						}>
							<Button
								onClick={() => {
									const [insertPosition,lastHeading] = getRoutineInsertPosition()
									dispatch(updateResourceLibrary({
										show: true,
										insertPosition,
										superset:0,
										heading:lastHeading,
										tgtResourceId:workout_id,
										tgtResourceType:'workout',
										resourceType:'exercise'
									}))
								}}
								variant={
									libraryIsOpen 
									? "outline-danger" 
									: "outline-success"
								}
								className="ml-1"
								size="sm"
							>
								{!libraryIsOpen ? "Exercise" : "Library"} <i className={
									libraryIsOpen 
									? "fas fa-times" 
									: "fas fa-plus"
								} />
							</Button>
						</OverlayTrigger>
					</div>
					<div className="d-flex align-items-center flex-wrap mb-3">
						<small>A rest/time with <i className="fa fa-play" /> is valid for guided workouts (<a href="#playable-workouts">see below</a>)</small>
					</div>
					<InsertExerciseButton workout_id={workout_id} insertPosition={1} allowHeadingInsert heading={0}/>
				</>
			}

			<DragDropContext onDragEnd={handleDragEnd}>
				<Droppable droppableId="routine-list" type="EXERCISES">
					{(provided, snapshot) => (
						<div
							{...provided.droppableProps}
							ref={provided.innerRef}
						>
							{
								//UX stuff: show a "get started" button if no exercises
								//otherwise render the routine
								routine.length === 0  ?
								  detailsLoading ? <Spinner animation="border" variant="primary" /> :
									<div className="d-flex justify-content-center py-5">
										{
											libraryIsOpen ?
												<strong>Now select from the list above</strong>
												:
												<Button
													onClick={() => {
														dispatch(updateResourceLibrary({
															show: true,
															insertPosition:1,
															superset:0,
															heading:0,
															tgtResourceType:'workout',
															tgtResourceId:workout_id,
															resourceType:'exercise'
														}))
													}}
													variant="outline-success"
													size="lg"
												>
													Click to start adding exercises
												</Button>
										}
									</div>
									:
									routine.map((routineItem, i) => {
										if (routineItem.type==='heading') {
											return (
												<Heading 
													toggleSelectedItems={toggleSelectedItems}
													isSelected={itemIsSelected(routineItem)}
													{...routineItem}
													idx={i}
												/>
											)
										} else if(routineItem.type==='placeholder') {
											return (
												<ExercisePlaceholder 
													routine_order={routineItem.routine_order} 
													workout_id={routineItem.workout_id}
													name={routineItem.name}
												/>
											)
										} else {
											return (
												<ExerciseGroup
													toggleSelectedItems={toggleSelectedItems}
													key={`exercise-group-${routineItem.id}`}
													compactMode={Boolean(workout.compact_mode)}
													isSelected={itemIsSelected(routineItem)}
													routineMode={mode}
													group={routineItem}
													idx={i}
												/>
											)
										}
									})
							}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
			{routine.length > 0 &&
				<div className="mt-2">
					<small className={isPlayable ? 'text-success' : 'text-danger'}>
						<i class="fas fa-play mr-1" />
						(optional) Automatic/Guided workout mode <strong>{isPlayable ? 'IS' : 'IS NOT'}</strong> enabled for this workout. <a href="#playable-workouts">what's this?</a>
					</small>
				</div>
			}
			<GroupMenu 
				items={selectedItems} 
				routine={routine} 
				workout_id={workout_id}
				clearItems={()=>{
					setSelectedItems([])
				}}
			/>
		</div>
	)
}

export default Routine